import React from 'react'

const ProviderList = ({data}) => {
  return (
    <div className={` ${data?.length === 0 && 'flex justify-center items-center'} ml-2 overflow-y-auto mt-2`} style={{ height: '550px'}}>
      {data?.map((item,index) => (<div key={index} className="block mb-2 max-w-sm p-4 bg-white border border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700">
        <p className="mb-2 text-base font-semibold tracking-tight text-gray-700">{item.enterpise_name} - {item.branch.endsWith(',') ? item.branch.slice(0, -1) : item.branch}</p>
      </div>))}
      {data?.length === 0 && <p className='font-semibold ml-4 text-gray-700 mb-2'>Providers details not available</p>}
    </div>
  )
}

export default ProviderList